import axios from 'axios';
import firebase from '../firebase/FirebaseProvider'

class SecureAxiosClient {
    constructor(isTokenRequired) {
        this.isTokenRequired = isTokenRequired;
    }

    async getService() {
        if(this.isTokenRequired) {
            this.token = await this.getIdToken();
        }
        //TODO: Remove before Alpha.
        const userId = localStorage.getItem('user_id');
        console.log("User Id:" + userId);
        let service = axios.create({
            headers: { 'Authorization': 'Bearer ' + this.token,
                        'mario-user_id': userId }
        });
        service.interceptors.response.use(this.handleSuccess, this.handleError);
        return service;       
    }

    async getIdToken() {
        console.log("Current User:" + firebase.auth().currentUser);
        this.currentUser = firebase.auth().currentUser;
        if (this.currentUser) {
            this.token = await this.currentUser.getIdToken();
            console.log("Current User:" + this.token);
            return this.token;
        }
        return null;
    }

    handleSuccess(response) {
        return response;
    }

    handleError = (error) => {
        console.error("Error from Secure API Call:", JSON.stringify(error));
        switch (error.response.status) {
            case 401:
                //this.redirectTo(document, '/')
                break;
            case 404:
                //this.redirectTo(document, '/404')
                break;
            default:
                //this.redirectTo(document, '/500')
                break;
        }
        return Promise.reject(error)
    }

    redirectTo = (document, path) => {
        document.location = path
    }

    shouldTriggerSecureRequest() {
        if(this.isTokenRequired && !this.currentUser) {
            return false;
        }
        return true;
    }

    async get(path, callback) {
        this.service = await this.getService();
        if(this.shouldTriggerSecureRequest) {
            return this.service.get(path).then(
                (response) => callback(response.status, response.data)
            ).catch(err => callback(err));
        }
    }

    async get(path) {
        this.service = await this.getService();
        return this.service.get(path);
    }

    async post(path, payload, callback) {
        this.service = await this.getService();
        if(this.shouldTriggerSecureRequest) {
            return this.service.request({
                method: 'POST',
                url: path,
                responseType: 'json',
                data: payload
            }).then((response) => callback(response.status, response.data));
        }
    }

    async delete(path, payload, callback) {
        this.service = await this.getService();
        if(this.shouldTriggerSecureRequest) {
            return this.service.request({
                method: 'DELETE',
                url: path,
                responseType: 'json',
                data: payload
            }).then((response) => callback(response.status, response.data));
        }
    }

    async putWithoutCallback(path, payload) {
        this.service = await this.getService();
        return this.service.request({
            method: 'PUT',
            url: path,
            responseType: 'json',
            data: payload
        });
    }

    async put(path, payload, callback) {
        this.service = await this.getService();
        if(this.shouldTriggerSecureRequest) {
            return this.service.request({
                method: 'PUT',
                url: path,
                responseType: 'json',
                data: payload
            }).then((response) => callback(response.status, response.data));
        }
    }
}
  
export default SecureAxiosClient;